import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { ChevronDown } from 'lucide-react';

/* ── QR CODE TOGGLE ─────────────────────────────────────────── */
export function QrToggle({ phone, brand, tc, ts }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-2xl border overflow-hidden" style={{ backgroundColor: `${tc}06`, borderColor: `${tc}08` }} data-testid="qr-toggle-card">
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between p-4 text-left transition-colors active:opacity-80"
        data-testid="qr-toggle-btn"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${brand.primary_color}20` }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={brand.primary_color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="3" height="3" /><line x1="21" y1="14" x2="21" y2="17" /><line x1="14" y1="21" x2="17" y2="21" /><line x1="21" y1="21" x2="21" y2="21.01" />
            </svg>
          </div>
          <div>
            <p className="text-sm font-semibold" style={{ color: tc }}>Il mio QR Code</p>
            <p className="text-xs" style={{ color: ts }}>Mostralo in cassa per il riconoscimento rapido</p>
          </div>
        </div>
        <ChevronDown size={18} style={{ color: ts }} className={`transition-transform duration-300 ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="px-4 pb-5 flex flex-col items-center animate-fade-in-up" data-testid="qr-code-display">
          <div className="bg-white rounded-2xl p-5 shadow-lg">
            <QRCodeSVG value={phone} size={180} level="M" />
          </div>
          <p className="text-[10px] mt-3" style={{ color: ts }}>Fai vedere questo codice al personale in cassa</p>
        </div>
      )}
    </div>
  );
}
